import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export const getFormName = async (orderId: string) => {
  try {
    const token = await getBearerToken();
    const response = await fetch(API_ENDPOINTS.GET_FORM_NAME, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ order_id: orderId }),
    });
    if (!response.ok) {
      throw new Error(`Failed to get form name for the order`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    logDataToConsole("error in getFormName", error);
    throw error;
  }
};
